var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _path9, _path0, _path1, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClapkartProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.4919,
    fill: "white",
    stroke: "#E4E7EC",
    strokeWidth: 1.01619
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.312 21.2475H40.0262V39.4157C40.0262 40.0959 39.4747 40.6474 38.7945 40.6474H13.5438C12.8635 40.6474 12.312 40.0959 12.312 39.4157V21.2475Z",
    fill: "#FEC353"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0264 39.4156C40.0264 40.0958 39.4751 40.6478 38.7949 40.648H26.168V23.0953H40.0264V39.4156Z",
    fill: "#FF9E39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3121 19.83C12.3121 18.9383 12.8934 18.1507 13.7455 17.8879L36.8531 10.7607C37.9257 10.4299 39.0634 11.0312 39.3942 12.1038L39.8843 13.6928L12.3121 22.356L12.3121 19.83Z",
    fill: "#4E5E82"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0457 12.5523L33.8324 11.6928L31.0794 16.4596L28.2814 17.3388L31.0457 12.5523Z",
    fill: "#E2E6F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7122 14.5058L27.4989 13.6462L24.7202 18.4577L21.9221 19.3369L24.7122 14.5058Z",
    fill: "#E2E6F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.213 16.5103L21.0001 15.6507L18.2421 20.4931L15.4438 21.3723L18.213 16.5103Z",
    fill: "#E2E6F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5562 15.3672L37.1118 10.942C37.7907 11.0163 38.4256 11.318 38.9115 11.7916L37.3542 14.4881L34.5562 15.3672Z",
    fill: "#E2E6F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.312,
    y: 21.2475,
    width: 27.7142,
    height: 3.69522,
    fill: "#3E4466"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0259 21.9809L36.5581 24.9428H33.7134L38.0415 21.2475H40.0259V21.9809Z",
    fill: "#CED6E7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1777 24.9428H27.333L31.6611 21.2475H34.5059L30.1777 24.9428Z",
    fill: "#CED6E7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7109 24.9428H20.8652L25.1934 21.2475H28.0391L23.7109 24.9428Z",
    fill: "#CED6E7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6812 24.9428H13.8364L18.1646 21.2475H21.0093L16.6812 24.9428Z",
    fill: "#CED6E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.0083,
    y: 28.6381,
    width: 20.3237,
    height: 0.923806,
    rx: 0.461903,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.0083,
    y: 36.0284,
    width: 20.3237,
    height: 0.923806,
    rx: 0.461903,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6274,
    y: 28.6381,
    width: 0.923806,
    height: 8.31425,
    rx: 0.461903,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7871,
    y: 28.6381,
    width: 0.923806,
    height: 8.31425,
    rx: 0.461903,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClapkartProfileIcon);
export default __webpack_public_path__ + "static/media/clapkart-profile-icon.a1785c1db4a013140758b26e9da51c8d.svg";
export { ForwardRef as ReactComponent };